import { c as _c } from "react/compiler-runtime";
import { CreateDropType } from "@/components/drops/create/types";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
export default function CreateDropFullMobileWrapper(t0) {
  const $ = _c(8);
  const {
    isOpen,
    type,
    onClose,
    onViewClick,
    children
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = () => {
      switch (type) {
        case CreateDropType.DROP:
          {
            return "Create a Post";
          }
        case CreateDropType.QUOTE:
          {
            return "Create a Quote";
          }
        default:
          {
            return "";
          }
      }
    };
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getTitle = t1;
  const t2 = getTitle();
  let t3;
  if ($[2] !== children || $[3] !== isOpen || $[4] !== onClose || $[5] !== onViewClick || $[6] !== t2) {
    t3 = <MobileWrapperDialog title={t2} isOpen={isOpen} onClose={onClose} onAfterLeave={onViewClick}>{children}</MobileWrapperDialog>;
    $[2] = children;
    $[3] = isOpen;
    $[4] = onClose;
    $[5] = onViewClick;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}